import toast from "react-hot-toast";

import { LISBlock, LISCase, LISSpecimen, LISTask } from "pwapi";

import { labelForBlock } from "util/blockUtils";

import FullScreenToast from "./FullScreenToast";

// NOTE: react-hot-toast injects styles into a <style> tag which will be
// *below* (thus overrides) style in the <head> of the document
// ... but __only for builds__ -- during development, all <style> is
// hot-reloaded and thus you don't see the same results as compiled style
const style = {
  background: "var(--red9)",
  maxWidth: "none",
  padding: 0,
};

export const toastErrorBlocksNotScannedOut = (
  pathCase: LISCase,
  scannedSpecimen: LISSpecimen,
  blocksNotScannedOut: LISBlock[]
) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Scan Error</h2>
        <h3>
          Block(s){" "}
          {blocksNotScannedOut
            .map((b) => labelForBlock(b, pathCase!))
            .join(", ")}{" "}
          have not been scanned out.{" "}
        </h3>
        <p>
          Please scan out cassettes before proceeding to Specimen{" "}
          {scannedSpecimen.name}.
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: 30000,
      className: "Toast--FullScreen",
      style,
    }
  );
};

export const toastErrorBlocksNotScannedOutMovingSpecimen = (
  pathCase: LISCase,
  blockSpecimen: LISSpecimen,
  scannedBlock: LISBlock,
  blocksNotScannedOut: LISBlock[]
) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Scan Warning</h2>
        <h3>
          You scanned {labelForBlock(scannedBlock, pathCase)}, but{" "}
          {blocksNotScannedOut
            .map((b) => labelForBlock(b, pathCase!))
            .join(", ")}{" "}
          have not yet been scanned out.
        </h3>
        <p>
          Please carefully consider the materials you are currently handling
        </p>
        <p>
          If you meant to scan {labelForBlock(scannedBlock, pathCase)}, scan out{" "}
          {blocksNotScannedOut
            .map((b) => labelForBlock(b, pathCase!))
            .join(", ")}{" "}
          first and then proceed with scanning{" "}
          {labelForBlock(scannedBlock, pathCase)}
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: 30000,
      className: "Toast--FullScreen",
      style,
    }
  );
};

export const toastErrorIncompleteGrossingTasks = (
  pathCase: LISCase,
  incompleteGrossingTasks: LISTask[]
) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Scan Error</h2>
        <h3>{pathCase.accession} has not completed grossing.</h3>
        <p>
          Please ensure {pathCase.accession} has fully completed grossing,
          including scanning out all printed cassettes, before proceeding.
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: 30000,
      className: "Toast--FullScreen",
      style,
    }
  );
};

export const toastErrorSpecimenDoesNotBelong = (pathCase: LISCase) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Extreme Warning</h2>
        <h1>
          The specimen you scanned does not belong to {pathCase?.accession}.
        </h1>
        <p>
          Please carefully consider the materials you are currently handling.
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: Infinity,
      className: "Toast--FullScreen",
      style,
    }
  );
};

export const toastErrorBlockDoesNotBelong = (
  pathCase: LISCase,
  specimen?: LISSpecimen
) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Extreme Warning</h2>
        <h1>
          The block you scanned does not belong to{" "}
          {specimen
            ? `${pathCase?.accession} Specimen ${specimen.name}`
            : pathCase?.accession}
          .
        </h1>
        <p>
          Please carefully consider the materials you are currently handling.
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: Infinity,
      className: "Toast--FullScreen",
      style,
    }
  );
};
